import React from 'react';
import axios from 'axios'
import { useFormik } from 'formik';
import './styles/form.css'
import * as Yup from 'yup'
import { loadProgressBar } from 'x-axios-progress-bar'
import 'x-axios-progress-bar/dist/nprogress.css'

//const port=process.env.REACT_APP_PORT2
const baseUrl= process.env.REACT_APP_HOST

const TreeForm=()=>{
    loadProgressBar()
    const formik = useFormik({
      initialValues: {
        PlantID: '',
        List: '',
        Taxon: '',
        Vernacular: '',
        BgLatitude: '',
        BgLongitude: '',
        GardenGrid: '',
        GardenSubGrid:''
          
      },
      validationSchema: Yup.object({
        PlantID: Yup.string().min(1).max(100, 'Please enter a tree id.').required('PlantID is Required'),
        List: Yup.string().min(1).max(100, 'Please enter a list number.').required('List is Required'),
        Taxon: Yup.string().min(1).max(100, 'Please enter a taxon.').required('Taxon is Required'),
        Vernacular: Yup.string().min(1).max(100, 'Please enter a vernacular.').required('Verncular is Required'),
        BgLatitude: Yup.string().min(1).max(100, 'Please enter the BgLatitude.').required('BgLatitude is Required'),
        BgLongitude: Yup.string().min(1).max(100, 'Please enter the BgLongitude.').required('BgLongitude is Required'),
        GardenGrid: Yup.string().min(1).max(100, 'Please enter the GardenGrid.').required('GardenGrid is Required'),
        GardenSubGrid: Yup.string().min(1).max(100, 'Please enter the GardenSubGrid.').required('GardenSubGrid is Required')
      }),
      onSubmit: values => {
                    axios.get(baseUrl+'sendTreeEntry',{
                        params:{
                            PlantID: formik.values.PlantID,
                            List: formik.values.List,
                            Taxon: formik.values.Taxon,
                            Vernacular: formik.values.Vernacular,
                            BgLatitude: formik.values.BgLatitude,
                            BgLongitude: formik.values.BgLongitude,
                            GardenGrid: formik.values.GardenGrid,
                            GardenSubGrid: formik.values.GardenSubGrid
                        }
                    }).then(res=>{
                        console.log("UPDATE TREE?",res.data,res.data=='23505')
                        if(res.data=='23505'){
                            if(window.confirm('Do you want to update this record?')){
                                axios.get(baseUrl+'updateTree',{
                                    params:{
                                        PlantID: formik.values.PlantID,
                                        List: formik.values.List,
                                        Taxon: formik.values.Taxon,
                                        Vernacular: formik.values.Vernacular,
                                        BgLatitude: formik.values.BgLatitude,
                                        BgLongitude: formik.values.BgLongitude,
                                        GardenGrid: formik.values.GardenGrid,
                                        GardenSubGrid: formik.values.GardenSubGrid
                                    }
                                }).then(result=>{
                                    console.log(result.data)
                                    alert('Tree entry updated.\n\n')
                                })
                            }else{
                                alert('Did not update tree.')
                            }
                        }else{
                            alert('New tree entry created.\n\n')
                        }
                    }).catch(err=>{alert(err.message)})
                    
      },
    })
        return(
            <div class="AddTreeForm">
                <legend>Tree Entry Form</legend>
                <form id="treeForm" onSubmit={formik.handleSubmit}>
                <table class="BasicInfoTable">
                    <tr>
                        <td>
                        <label class="BasicInfoLabel">Tree ID</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                type="text" 
                                name="PlantID" 
                                id="PlantID"
                                onChange={formik.handleChange} 
                                value={formik.values.PlantID}
                                list="treeIDList"
                                onFocus={()=>{
                                    
                                        axios.get(baseUrl+'findTree',{
                                            params: {
                                                PlantID: formik.values.PlantID
                                            }
                                        }).then(result=>{
                                            if(result.data=='Tree ID not in database'){
                                                
                                               
                                                axios.get(baseUrl+'getAllTrees').then(res=>{
                                                    var treeslist=document.getElementById("treeIDList")
                                                    while(treeslist.hasChildNodes()){
                                                    treeslist.removeChild(treeslist.firstChild)
                                                    }
                                                    var tree;
                                                    var option;
                                                    for(tree in res.data){
                                                        option=document.createElement("option")
                                                        option.value=res.data[tree].PlantID
                                                        option.label=res.data[tree].PlantID
                                                        document.getElementById("treeIDList").appendChild(option)
                                                    }
                                                })
                                            }
                                            
                                        })
                                    
                                }}
                                onBlur={()=>{
                                    
                                    axios.get(baseUrl+'findTree',{
                                        params: {
                                            PlantID: formik.values.PlantID
                                        }
                                    }).then(result=>{
                                        if(result.data=='Tree ID not in database'){
                                            
                                           
                                            axios.get(baseUrl+'getAllTrees').then(res=>{
                                                var treeslist=document.getElementById("treeIDList")
                                                while(treeslist.hasChildNodes()){
                                                treeslist.removeChild(treeslist.firstChild)
                                                }
                                                var tree;
                                                var option;
                                                for(tree in res.data){
                                                    option=document.createElement("option")
                                                    option.value=res.data[tree].PlantID
                                                    option.label=res.data[tree].PlantID
                                                    document.getElementById("treeIDList").appendChild(option)
                                                }
                                            })
                                        }
                                        
                                    })
                                
                            }}
                                ></input>
                                <datalist id="treeIDList"></datalist>
                        </td>

                    </tr>
                   
                    {formik.touched.PlantID && formik.errors.PlantID? (<div class="Error">{formik.errors.PlantID}</div>) : null}
                    <tr>
                        <td></td>
                        <td>
                            <div class="infoButton">
                                <button type="button" class="btn btn-success" onClick={()=>{
                                    if(!(formik.values.PlantID=='')&&!(formik.values.PlantID.match(/[0-9|a-z]+-[0-9]{2,4}\*[0-9]+/)=='')){
                                        axios.get(baseUrl+'getTreeInfo',{params:{plantid:formik.values.PlantID}}).then(res=>{
                                            if(res.data.length!==0){
                                            var plantid=res.data[0].PlantID
                                            var list=res.data[0].List
                                            var taxon=res.data[0].Taxon
                                            var vernacular=res.data[0].Vernacular
                                            var bgLatitude=res.data[0].BgLatitude
                                            var bgLongitude=res.data[0].BgLongitude
                                            var gardenGrid=res.data[0].GardenGrid
                                            var gardenSubGrid=res.data[0].GardenSubGrid
                                            
                                            alert('PlantID: '+plantid+'\n\n'+
                                                    'List: '+list+'\n\n'+
                                                    'Taxon: '+taxon+'\n\n'+
                                                    'Vernacular: '+vernacular+'\n\n'+
                                                    'BgLatitude: '+bgLatitude+'\n\n'+
                                                    'BgLongitude: '+bgLongitude+'\n\n'+
                                                    'GardenGrid: '+gardenGrid+'\n\n'+
                                                    'GardenSubGrid: '+gardenSubGrid+'\n\n')
                                                    formik.values.PlantID=plantid
                                                    formik.values.List=list
                                                    formik.values.Taxon=taxon
                                                    formik.values.Vernacular=vernacular
                                                    formik.values.BgLatitude=bgLatitude
                                                    formik.values.BgLongitude=bgLongitude
                                                    formik.values.GardenGrid=gardenGrid
                                                    formik.values.GardenSubGrid=gardenSubGrid
                                                    document.getElementById("PlantID").value=plantid
                                                    document.getElementById("List").value=list
                                                    document.getElementById("Taxon").value=taxon
                                                    document.getElementById("Vernacular").value=vernacular
                                                    document.getElementById("BgLatitude").value=bgLatitude
                                                    document.getElementById("BgLongitude").value=bgLongitude
                                                    document.getElementById("GardenGrid").value=gardenGrid
                                                    document.getElementById("GardenSubGrid").value=gardenSubGrid
                                            }  
                                        })
                                    }
                                }}>
                                    Get Info.
                                </button>
                       
                            </div>
                            <div class="deleteButton">
                                <button type="button" class="btn btn-success"onClick={()=>{
                                    if(window.confirm('Are you sure you want to delete this record?')){
                                        axios.get(baseUrl+'deleteTree',{params:{plantid:formik.values.PlantID}}).then(res=>{
                                                alert(res.data)
                                        })
                                    }
                                    else{
                                        alert('Record not deleted.')
                                    }
                                }}>
                                    Delete Tree
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label class="BasicInfoLabel">List</label>
                        </td>
                        <td>
                            <input class="BasicInput"
                                type="text"
                                name="List" 
                                id="List"
                                onChange={formik.handleChange} 
                                value={formik.values.List}
                             ></input>
                        </td>
                    </tr>
                    {formik.touched.List && formik.errors.List? (<div class="Error">{formik.errors.List}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">Taxon</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                    type="text"
                                    name="Taxon"
                                    id="Taxon"
                                    onChange={formik.handleChange} 
                                    value={formik.values.Taxon}
                                    ></input>
                        </td>
                    </tr>
                    {formik.touched.Taxon && formik.errors.Taxon? (<div class="Error">{formik.errors.Taxon}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">Vernacular</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                    type="text"
                                    name="Vernacular"
                                    id="Vernacular"
                                    onChange={formik.handleChange} 
                                    value={formik.values.Vernacular}
                                    ></input>
                        </td>
                    </tr>
                    {formik.touched.Vernacular && formik.errors.Vernacular? (<div class="Error">{formik.errors.Vernacular}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">BgLatitude</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                    type="text"
                                    name="BgLatitude"
                                    id="BgLatitude"
                                    onChange={formik.handleChange} 
                                    value={formik.values.BgLatitude}
                                    ></input>
                        </td>
                    </tr>
                    {formik.touched.BgLatitude && formik.errors.BgLatitude? (<div class="Error">{formik.errors.BgLatitude}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">BgLongitude</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                    type="text"
                                    name="BgLongitude"
                                    id="BgLongitude"
                                    onChange={formik.handleChange} 
                                    value={formik.values.BgLongitude}
                                    ></input>
                        </td>
                    </tr>
                    {formik.touched.BgLongitude && formik.errors.BgLongitude? (<div class="Error">{formik.errors.BgLongitude}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">GardenGrid</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                    type="text"
                                    name="GardenGrid"
                                    id="GardenGrid"
                                    onChange={formik.handleChange} 
                                    value={formik.values.GardenGrid}
                                    ></input>
                        </td>
                    </tr>
                    {formik.touched.GardenGrid && formik.errors.GardenGrid? (<div class="Error">{formik.errors.GardenGrid}</div>) : null}

                    <tr>
                        <td>
                            <label class="BasicInfoLabel">GardenSubGrid</label>
                        </td>
                        <td>
                            <input class="BasicInput" 
                                    type="text"
                                    name="GardenSubGrid"
                                    id="GardenSubGrid"
                                    onChange={formik.handleChange} 
                                    value={formik.values.GardenSubGrid}
                                    ></input>
                        </td>
                    </tr>
                    {formik.touched.GardenSubGrid && formik.errors.GardenSubGrid? (<div class="Error">{formik.errors.GardenSubGrid}</div>) : null}

                </table>
                <div class="submitForm">
                    <button class=" btn btn-success" type="submit">
                            Create/Update
                    </button>
                </div>
                </form>
            </div>
        )
}
 
export default TreeForm;
